import { DietIcon } from "@/features/diets/components/diet-icon";
import type { SerializedTag } from "@/features/diets/helpers/serialize-tags";
import type { FilterMultiType } from "@/features/filters/types/filter-multi.type";
import type { FiltersSetup } from "@/features/filters/types/filters-setup.type";
import {
  FilterMulti,
  type FilterMultiProps,
} from "./filter-multi/filter-multi";

type FilterTagsProps = Omit<FilterMultiProps, "filter" | "paramName"> & {
  filtersSetup: FiltersSetup;
  serializedTags: SerializedTag[];
  paramName?: string;
};

export const FilterTags = (params: FilterTagsProps) => {
  const {
    filtersSetup,
    serializedTags,
    paramName = "tagsSlugs",
    collapsible,
    ...rest
  } = params;

  return (
    <FilterMulti
      collapsible={params.collapsible}
      filter={{
        label: "",
        name: paramName,
        total: params.filtersSetup.tags.length,
        value: [],
        options: params.serializedTags.map((tag) => ({
          label: (
            <span className="flex items-center gap-2">
              <DietIcon className="h-6 w-6" tag={tag.slug} /> {tag.label}
            </span>
          ),
          value: tag.slug,
          additional: "additional" in tag ? tag.additional : undefined,
        })),
      }}
      paramName={paramName}
      type="button"
      {...rest}
    />
  );
};
